import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=b7124ca6&scoped=true"
import script from "./horizontal.vue?vue&type=script&lang=js"
export * from "./horizontal.vue?vue&type=script&lang=js"
import style0 from "./horizontal.vue?vue&type=style&index=0&id=b7124ca6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7124ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7124ca6')) {
      api.createRecord('b7124ca6', component.options)
    } else {
      api.reload('b7124ca6', component.options)
    }
    module.hot.accept("./horizontal.vue?vue&type=template&id=b7124ca6&scoped=true", function () {
      api.rerender('b7124ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navMenu/horizontal.vue"
export default component.exports